export const StaxMark = ({ size = 34, className = "", dark = false }) => (
  <img
    src={dark ? "/logo-mark-white.png" : "/logo-mark.png"}
    alt=""
    aria-hidden="true"
    className={className}
    style={{ height: size, width: "auto" }}
  />
);

export const StaxLogo = ({ dark = false, size = 26 }) => (
  <img
    src={dark ? "/logo-horizontal-white.png" : "/logo-horizontal.png"}
    alt="STAX MARKETING"
    data-testid="stax-logo"
    style={{ height: size, width: "auto" }}
  />
);
